import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "dropzone"]

  connect() {
    this.element.addEventListener("dragover", this.handleDragOver.bind(this))
    this.element.addEventListener("dragleave", this.handleDragLeave.bind(this))
    this.element.addEventListener("drop", this.handleDrop.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("dragover", this.handleDragOver.bind(this))
    this.element.removeEventListener("dragleave", this.handleDragLeave.bind(this))
    this.element.removeEventListener("drop", this.handleDrop.bind(this))
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.element.classList.add("border-accent", "bg-accent/10")
    this.element.classList.remove("border-gray-600")
  }

  handleDragLeave(event) {
    event.preventDefault()
    event.stopPropagation()

    // Only remove highlight if we're leaving the dropzone completely
    if (event.target === this.element) {
      this.element.classList.remove("border-accent", "bg-accent/10")
      this.element.classList.add("border-gray-600")
    }
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()

    this.element.classList.remove("border-accent", "bg-accent/10")
    this.element.classList.add("border-gray-600")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      // Update the file input
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(files[0])
      this.inputTarget.files = dataTransfer.files

      // Show preview if it's an image
      if (files[0].type.startsWith('image/')) {
        this.showPreview(files[0])
      }

      // Trigger change event on the input
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  showPreview(file) {
    if (!this.hasPreviewTarget) return

    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result
      this.previewTarget.classList.remove('hidden')
    }
    reader.readAsDataURL(file)
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file && file.type.startsWith('image/')) {
      this.showPreview(file)
    }
  }
}
